import React from "react";

import {
  vikrant,
  meenakshi,
  divya,
  aditi,
  akash,
  chinmay,
  khushi,
  madhav,
  mohak,
  ramit,
  rupashi,
  shivangi,
  shivank,
  suparnBhaiya,
  suwani,
  aditya,
  akriti,
  shubham,
} from "../assets/new/index";

const Member = ({ user, name, position }) => {
  return (
    <div className="imageCard cursor-pointer">
      <img src={user} alt={user} />
      <span className="">
        <div className="text text-center font-montserrat">
          <h1 className="text-lg font-bold">Rtr. {name}</h1>
          <h3 className="font-bold text-mix-400">{position}</h3>
        </div>
      </span>
    </div>
  );
};

function Team() {
  return (
    <div className="max-w-7xl mx-auto mb-10 mt-32">
      <h1 className="text-center font-semibold text-7xl text-mix-400 mb-10 font-josefin">
        Meet The Team
      </h1>
      <div className="mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
          <div className="imageCard cursor-pointer lg:col-span-2 md:col-span-1">
            <img src={suparnBhaiya} alt="suparn-bhaiya" />
            <span>
              <div className="text text-center font-montserrat">
                <h1 className="text-lg font-bold">Rtr. Suparn Kumar</h1>
                <h3 className="font-bold text-mix-400">IPP & Club Advisor</h3>
              </div>
            </span>
          </div>
          <div className="imageCard cursor-pointer lg:col-span-2 md:col-span-1">
            <img src={akash} alt="akash" />
            <span>
              <div className="text text-center font-montserrat">
                <h1 className="text-lg font-bold">Rtr. Akash Samal</h1>
                <h3 className="font-bold text-mix-400">President</h3>
              </div>
            </span>
          </div>
          <Member
            user={mohak}
            name="Mohak Sharma"
            position="Vice-President & Secretary"
          />
          <Member
            user={ramit}
            name="Ramit Batra"
            position="Treasurer & RYLA Representative"
          />
          <Member user={khushi} name="Khushi" position="Sergeant-at-Arms" />
          <Member
            user={aditi}
            name="Aditi Sharma"
            position="Director of Education Dept"
          />
          <Member
            user={rupashi}
            name="Rupashi Goel"
            position="Director of Healthcare Dept"
          />
          <Member
            user={madhav}
            name="Madhav Budhiraja"
            position="Director of Environment Dept"
          />
          <div className="imageCard cursor-pointer">
            <img src={shivangi} alt="shivangi" />
            <span>
              <div className="text text-center font-montserrat">
                <h1 className="text-lg font-bold">Rtr. Shivangi Dubey</h1>
                <h3 className="font-bold text-mix-400">
                  <div>Director of Professional</div>
                  <div>Development Dept</div>
                </h3>
              </div>
            </span>
          </div>
          <Member
            user={shivank}
            name="Shivank Sadwal"
            position="Director of Editorial Team"
          />
          <Member
            user={chinmay}
            name="Chinmay Takkar"
            position="Director of Sponsorship & PR"
          />
          <Member
            user={divya}
            name="Divya Sharma"
            position="Co-Director of Healthcare Dept"
          />
          <Member
            user={vikrant}
            name="Vikrant Singh Bhadauria"
            position="Co-Director of Editorial Team"
          />
          <Member
            user={meenakshi}
            name="Meenakshi Singh"
            position="Co-Director of Environment Dept"
          />
          <div className="imageCard cursor-pointer">
            <img src={suwani} alt="suwani" />
            <span>
              <div className="text text-center font-montserrat">
                <h1 className="text-lg font-bold">Rtr. Suwani Bothra</h1>
                <h3 className="font-bold text-mix-400">
                  <div>Director of Intenational Services</div>
                  <div>& Community Services</div>
                </h3>
              </div>
            </span>
          </div>
          <div className="imageCard cursor-pointer">
            <img src={shubham} alt="shubham" />
            <span>
              <div className="text text-center font-montserrat">
                <h1 className="text-lg font-bold">Rtr. Shubham Sharma</h1>
                <h3 className="font-bold text-mix-400">
                  <div>Co-Director of Professional</div>
                  <div>Development Dept</div>
                </h3>
              </div>
            </span>
          </div>
          <Member
            user={akriti}
            name="Akriti Ajit"
            position="Co-Director of Education Dept"
          />
          <Member
            user={aditya}
            name="Aditya Akash"
            position="Co-Director of Social Media Dept"
          />
        </div>
      </div>
    </div>
  );
}

export default Team;
